'use client';

import styles from './StackShowcaseSection.module.scss';
import { StackShowcase, StackStep } from '../StackShowcase/StackShowcase';

export interface StackShowcaseSectionProps {
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  description?: string;
  footerEnd?: string;
  steps?: StackStep[];
}

export const StackShowcaseSection = ({
  eyebrow,
  title,
  subtitle,
  description,
  footerEnd,
  steps,
}: StackShowcaseSectionProps) => {
  const hasHeader = eyebrow || title || subtitle || description;

  return (
    <div className={styles.root}>
      {hasHeader && (
        <div className={styles.header}>
          {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
          {title && <h2 className={styles.title}>{title}</h2>}
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          {description && <p className={styles.description}>{description}</p>}
        </div>
      )}
      <StackShowcase steps={steps} footerEnd={footerEnd} />
    </div>
  );
};
